export default __webpack_public_path__ + "static/media/warning--bicycles-and-others--g1.64fe6c90.png";